export default __webpack_public_path__ + "ba88f51fda4226408e541f3101cc7e00.png";